export enum LegendPosition {
  FLOATING = 'floating',
  ATTACHED = 'attached',
}

export type LegendPositionConfiguration = {
  legendPosition: LegendPosition;
};

export type DbPersistedLegendPositionConfig = LegendPositionConfiguration;

export const DB_PERSISTED_LEGEND_POSITION_CONFIG_KEY: keyof DbPersistedLegendPositionConfig =
  'legendPosition';

export function isLegendPosition(value: any): value is LegendPosition {
  return Object.values(LegendPosition).includes(value);
}
